import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/pagination";
import "./Testimonial.css";

const testimonials = [
  {
    img: "images/1.png",
    name: "Sanghvi Interior Gallery",
    // role: "CEO & Founder",
    text: "I had a fantastic experience with The PodSutra Studio! They offer the best pricing while maintaining top-notch quality. Their creativity and color balancing skills are outstanding, and they have so many background options to choose from. The studio is equipped with the best equipment, and their team and anchors are highly professional. If you're looking for affordable pricing with premium services, The PodSutra Studio is the place to go! 😊👍",
  },
 
  {
    img: "/images/9.png",
    name: "Dhruv Shiroya",
    // role: "Designer",
    text: "The PodSutra Studio offers the best pricing while delivering top-notch quality! Their creativity, color balancing, and background options make every shoot stand out. The best team and anchors ensure a smooth experience. Highly recommended! 😊",
  },
  {
    img: "/images/6.png",
    name: "Vatsal",
    // role: "Designer",
    text: "Affordable pricing with premium quality! The studio has the best equipment, experienced anchors, and a talented team. Great experience overall!",
  },
  {
    img: "/images/7.png",
    name: "Dharmaraj Mangrola",
    // role: "Designer",
    text: "Had an amazing time at The PodSutra Studio! Their attention to detail in color balancing is impressive, and the variety of backgrounds adds so much depth. Best pricing and best team!",
  },
  {
    img: "/images/3.png",
    name: "Rushabh Patel",
    // role: "Designer",
    text: "Amazing setup, and most cost effective in town.",
  },
  // {
  //   img: "testi3.png",
  //   name: "Jena Karlis",
  //   role: "Store Owner",
  //   text: "Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor...",
  // },
  // {
  //   img: "testi1.png",
  //   name: "Matt Brandon",
  //   role: "Freelancer",
  //   text: "Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit minim dolor...",
  // },
  // {
  //   img: "testi2.png",
  //   name: "John Larson",
  //   role: "Entrepreneur",
  //   text: "Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam enim culpa labore duis sunt...",
  // },
];

const Testimonial = () => {
  return (
    <section id="testimonials">
      <div className="container">
        <header className="section-header">
          <h3 style={{
          fontSize: "clamp(2rem, 5vw, 2.5rem)", // Responsive font size
          fontWeight: "bold",
          textTransform: "uppercase",
          letterSpacing: "2px",
          color: "#fdac00",
          marginBottom: "3rem",
         
          
        }}>                {Array.from(" Testimonials").map((char, index) => (
          <motion.span
            key={index}
            style={{
              display: "inline-block",
              color: "#fdac00", // Yellow color
              padding: "0 0px",
              cursor: "pointer",
            }}
            whileHover={{ y: -8 }} // Moves up slightly on hover
            transition={{ type: "spring", stiffness: 300, damping: 10 }}
          >
                {char === " " ? "\u00A0" : char} {/* Handles spaces correctly */}
          </motion.span>
        ))}
         
        </h3>

        </header>

        <Swiper
          modules={[Pagination, Autoplay]}
          loop={true}   
          autoplay={{ delay: 3000 }}
          pagination={{ clickable: true }}
          spaceBetween={50}
          slidesPerView={1}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-item">
                <img src={testimonial.img} className="testimonial-img" alt={testimonial.name} />
                <h3>{testimonial.name}</h3>
                <h4>{testimonial.role}</h4>
                <p>{testimonial.text}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonial;
